import React from 'react';
import PropTypes from 'prop-types';
import {
    Backdrop,
    Modal,
    Fade,
    Grid,
    Typography,
    IconButton,
    Divider
} from '@mui/material';
import { CloseIcon, UploadLogoIcon } from '@/resources/icons';
import useStyles from './styles';

const GenericUploadModal = ({
    children,
    onClose,
    open,
    heading,
    icon,
    overDrawer
}) => {
    const classes = useStyles();

    return (
        <Modal
            className={classes.centerDivContent}
            open={open}
            onClose={onClose}
            closeAfterTransition
            slots={{
                backdrop: Backdrop
            }}
            slotProps={{
                backDropProps: {
                    invisible: overDrawer,
                    timeout: 500
                }
            }}
        >
            <Fade in={open}>
                <div
                    className={`${classes.paper} ${
                        overDrawer && classes.modalShadow
                    }`}
                >
                    <Grid container direction="column">
                        <Grid container>
                            <Grid item className={classes.icon}>
                                <div className={classes.svg}>{icon}</div>
                            </Grid>
                            <Grid item>
                                <Typography
                                    variant="h6"
                                    className={classes.heading}
                                >
                                    {heading}
                                </Typography>
                            </Grid>
                            <Grid item className={classes.close} sm={1} xs={2}>
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                    size="large"
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Divider className={classes.divider} />
                        </Grid>
                        <Grid item className={classes.centerDivContent}>
                            {children}
                        </Grid>
                    </Grid>
                </div>
            </Fade>
        </Modal>
    );
};

GenericUploadModal.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    heading: PropTypes.string.isRequired,
    icon: PropTypes.node,
    overDrawer: PropTypes.bool
};

GenericUploadModal.defaultProps = {
    children: null,
    onClose: () => {},
    open: false,
    icon: <UploadLogoIcon />,
    overDrawer: false
};

export default GenericUploadModal;
